// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YpfX","left":"styles_left__1zDgD"};